// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3yuZS","col":"CardReaderDesc_col__3ywAg","label":"CardReaderDesc_label__2qL16"};